<div class=" costlabortab">
  <fieldset class="border rounded-3 p-1 cost-element-all">
    <legend class="float-none w-auto px-1 ml-1 font-size-13">{{'REVIEW_SOL_LABOR_AND_COSTS_TAB.TITLE' | translate}}
    </legend>
    <div class="row m-0 justify-content-between">
      <div class="col-md-5 py-0 px-3">
        <div class="custom-table h-100">
          <div class="example-container d-flex flex-column h-100">
            <table mat-table [dataSource]="dataSourceLabor" class="custom-table  table table-bordered no-border">
              <!-- Define columns -->
              <ng-container matColumnDef="itemName">
                <th mat-header-cell *matHeaderCellDef class="col-sm-3">
                  {{'REVIEW_SOL_LABOR_AND_COSTS_TAB.LABOR' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" class="row-height">
                  {{element.itemName}}
                </td>
                <td mat-footer-cell *matFooterCellDef class="ps-2 font-size-12">{{'TOTAL' | translate}}</td>
              </ng-container>

              <ng-container matColumnDef="itemCost">
                <th mat-header-cell *matHeaderCellDef>
                  {{'REVIEW_SOL_LABOR_AND_COSTS_TAB.COST' | translate}}
                </th>
                <td mat-cell class=" text-end row-height" *matCellDef="let element">
                  {{element.itemCost | multilingualCurrency}}
                </td>
                <td mat-footer-cell *matFooterCellDef class="text-end font-size-12">{{totalCostLaborTable |
                  multilingualCurrency}}</td>
              </ng-container>

              <ng-container matColumnDef="tdcPercent">
                <th mat-header-cell *matHeaderCellDef>
                  {{'REVIEW_SOL_LABOR_AND_COSTS_TAB.TDC_PERCENT' | translate}}
                </th>
                <td mat-cell class="text-end row-height" *matCellDef="let element">
                  {{element.tdcPercent | decimalPrecision}}%
                </td>
                <td mat-footer-cell *matFooterCellDef class="text-end font-size-12  overflow-visible">
                  <span class="position-relative d-inline-block">
                    {{totalPercentOfTDCLaborTable | decimalPrecision}}%
                    @if(isLaborTDCPercentExceeds){
                    <mat-icon class="position-absolute start-100 top-50 translate-middle-y info-icon"
                      [matTooltip]="'REVIEW_SOL_LABOR_AND_COSTS_TAB.REASON_FOR_LABOR_VARIANCE_TOOLTIP' | translate">info</mat-icon>
                    }
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="target">
                <th mat-header-cell *matHeaderCellDef>
                  {{'REVIEW_SOL_LABOR_AND_COSTS_TAB.MINIMUM' | translate}}
                </th>
                <td mat-cell class="row-height" *matCellDef="let element">
                  @if(element.targetVisible){
                  <div class="d-flex align-items-center justify-content-between">
                    @if(element?.isFlagVisible){
                    <mat-icon class="flag-icon-position">flag</mat-icon>
                    }@else{
                    <span></span>
                    }
                    @if(element.target !== 0){
                    <span class="d-flex justify-content-end">
                      {{element.target | decimalPrecision}}%
                    </span>
                    }
                  </div>
                  }
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <ng-container matColumnDef="nationalHistoricTDCPercent">
                <th mat-header-cell *matHeaderCellDef>
                  {{'REVIEW_SOL_LABOR_AND_COSTS_TAB.ZONE_PY_TDC_PERCENT' | translate}}
                </th>
                <td mat-cell class=" text-end row-height" *matCellDef="let element">
                  @if(element.isNationalHistoricalHidden){
                  {{element.nationalHistoricTDCPercent | decimalPrecision}}%
                  }
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <ng-container matColumnDef="hours">
                <th mat-header-cell *matHeaderCellDef>
                  {{'REVIEW_SOL_LABOR_AND_COSTS_TAB.HOURS' | translate}}
                </th>
                <td mat-cell class=" text-end row-height" *matCellDef="let element">
                  {{element.hours | decimalPrecision}}
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>


              <!-- Header row -->
              <tr mat-header-row *matHeaderRowDef="activeDisplayedColumnsLabor; sticky: true"></tr>
              <!-- Data rows -->
              <tr mat-row *matRowDef="let row; columns: activeDisplayedColumnsLabor;" class="row-height"></tr>
              <!-- Footer row -->
              <tr mat-footer-row *matFooterRowDef="activeDisplayedColumnsLabor" class="table-footer"></tr>
              <!-- Row shown when there is no matching data -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data" [attr.colspan]="activeDisplayedColumnsLabor.length">
                  {{'COMMON_LABELS.NO_DATA_FOUND' | translate}}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="col-md-5 py-0 px-3">
        <div class="custom-table h-100">
          <div class="example-container h-100 d-flex flex-column">
            <table mat-table [dataSource]="dataSourceItem" class="custom-table   table table-bordered no-border">
              <!-- Define columns -->
              <ng-container matColumnDef="itemName">
                <th mat-header-cell *matHeaderCellDef class="col-sm-3"> {{'REVIEW_SOL_LABOR_AND_COSTS_TAB.ITEM' |
                  translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.itemName}} </td>
                <td mat-footer-cell *matFooterCellDef class="ps-2 font-size-12">{{'TOTAL' | translate}}</td>
              </ng-container>

              <ng-container matColumnDef="itemCost">
                <th mat-header-cell *matHeaderCellDef> {{'REVIEW_SOL_LABOR_AND_COSTS_TAB.COST' | translate}} </th>
                <td mat-cell class=" text-end" *matCellDef="let element"> {{element.itemCost | multilingualCurrency}}
                </td>
                <td mat-footer-cell *matFooterCellDef class="text-end font-size-12">{{totalCostItemTable |
                  multilingualCurrency}}</td>
              </ng-container>

              <ng-container matColumnDef="tdcPercent">
                <th mat-header-cell *matHeaderCellDef> {{'REVIEW_SOL_LABOR_AND_COSTS_TAB.TDC_PERCENT' | translate}}
                </th>
                <td mat-cell class=" text-end" *matCellDef="let element"> {{element.tdcPercent | decimalPrecision}}%
                </td>
                <td mat-footer-cell *matFooterCellDef class="text-end font-size-12">{{totalPercentOfTDCItemTable |
                  decimalPrecision}}%</td>
              </ng-container>

              <ng-container matColumnDef="riskDisplayText">
                <th mat-header-cell *matHeaderCellDef> {{'REVIEW_SOL_LABOR_AND_COSTS_TAB.MINIMUM' | translate}}</th>
                <td mat-cell class=" text-end" *matCellDef="let element">
                  @if(element.targetVisible){
                  {{element.riskDisplayText | decimalPrecision}}%
                  }
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <ng-container matColumnDef="nationalHistoricTDCPercent">
                <th mat-header-cell *matHeaderCellDef>
                  {{'REVIEW_SOL_LABOR_AND_COSTS_TAB.ZONE_PY_TDC_PERCENT' | translate}}
                </th>
                <td mat-cell class=" text-end" *matCellDef="let element">
                  @if(element.isNationalHistoricalHidden){
                  {{element.nationalHistoricTDCPercent | decimalPrecision}}%
                  }
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <!-- Header row -->
              <tr mat-header-row *matHeaderRowDef="activeDisplayedColumnsItem; sticky: true"></tr>
              <!-- Data rows -->
              <tr mat-row *matRowDef="let row; columns: activeDisplayedColumnsItem;" class="row-height"></tr>
              <!-- Footer row -->
              <tr mat-footer-row *matFooterRowDef="activeDisplayedColumnsItem" class="table-footer"></tr>
              <!-- Row shown when there is no matching data -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data" [attr.colspan]="activeDisplayedColumnsItem.length">
                  {{'COMMON_LABELS.NO_DATA_FOUND' | translate}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-0">
      <div class="col-md-5 p-0">
        @if(isLaborTDCPercentExceeds){
        <div class="row m-0">
          <div class="col-sm-4 horizontal-padding">
            <mat-label>{{'REVIEW_SOL_LABOR_AND_COSTS_TAB.REASON_FOR_LABOR_VARIANCE' | translate}}</mat-label>
          </div>
          <div class="col-sm-8 horizontal-padding">
            <si-combo-box [inputValue]="reasonForLaborVariance" [dropDownList]="reasonForLaborVarianceDropDownData"
              [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
              (inputValueChange)="onReasonForLaborVarianceChange($event)"></si-combo-box>
          </div>
        </div>
        }
        @if(isEngineerExceptionApplicable){
        <fieldset class="border rounded-3 p-1">
          <legend class="float-none w-auto px-1 ml-1 font-size-13 d-flex align-items-center">
            {{'REVIEW_SOL_LABOR_AND_COSTS_TAB.ENG_LABOR_BELOW_EXPECTED_TDC' | translate}}
            <span [matTooltipDisabled]="isDisabled"
              [matTooltip]="'REVIEW_SOL_LABOR_AND_COSTS_TAB.ENG_LABOR_BELOW_EXPECTED_TDC_TOOLTIP' | translate"
              matTooltipPosition="right" matTooltipClass="custom-tooltip">
              <mat-icon class="info-icon">info_outline</mat-icon>
            </span>
          </legend>
          <div [formGroup]="SolCostAndLaborFormGroup" trackChanges>
            <div class="row m-0 align-items-center">
              <div class="col-sm-4 horizontal-padding">
                <mat-label>{{'REVIEW_SOL_LABOR_AND_COSTS_TAB.BRANCH_ZOM_APPROVAL_RECEIVED' | translate}}</mat-label>
              </div>
              <div class="col-sm-8 horizontal-padding">
                <mat-radio-group class=" d-flex align-items-center" formControlName="engZomApproveReceivedFormControl">
                  <si-radio-button [displayText]="'YES' | translate" [isReadMode]="false" [isDisabled]="isDisabled"
                    [selectedValue]="SolCostAndLaborFormGroup.controls['engZomApproveReceivedFormControl'].value"></si-radio-button>
                  <si-radio-button [displayText]="'NO' | translate" [isReadMode]="false" [isDisabled]="isDisabled"
                    [selectedValue]="SolCostAndLaborFormGroup.controls['engZomApproveReceivedFormControl'].value"></si-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div class="row m-0 align-items-center">
              <div class="col-sm-4 horizontal-padding">
                <mat-label>{{'REVIEW_SOL_LABOR_AND_COSTS_TAB.APPROVERS_EMAIL' | translate}}</mat-label>
              </div>
              <div class="col-sm-8 p-2">
                <app-si-form-field [inputValue]="engApproverEmailId" [isReadMode]="isReadOnlyMode"
                  [isDisabled]="isDisabled"
                  (inputValueChange)="SolCostAndLaborFormGroup.controls['approverEmailId'].setValue($event.toString())"></app-si-form-field>
              </div>
            </div>
            <div class="row m-0 align-items-center">
              <div class="col-sm-4 horizontal-padding">
                <mat-label>{{'REVIEW_SOL_LABOR_AND_COSTS_TAB.REASON_FOR_EXCEPTION' | translate}}</mat-label>
              </div>
              <div class="col-sm-8 horizontal-padding">
                <si-combo-box [inputValue]="engReasonForexception" [dropDownList]="reasonsForExceptionDropDownData"
                  [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
                  (inputValueChange)="SolCostAndLaborFormGroup.controls['reasonForException'].setValue($event)">
                </si-combo-box>
              </div>
            </div>
          </div>
        </fieldset>
        }
      </div>
    </div>
  </fieldset>
</div>